var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary--text text--darken-2"},[[_c('v-select',{attrs:{"value":_vm.value,"items":_vm.items,"item-value":_vm.itemValue,"item-text":"name","return-object":""},on:{"change":_vm.save}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }